import '../styles/techEdgeCard.css';

const TechEdgeCard = ({ techEdgeItem, selected, onClick }) => {
    const { img, tech, description } = techEdgeItem;


    let cardClassName = "techedge-card";
    let cardDescriptionName  = "techedge-description";
    let cardTitleName = "techedge-card-title";

    if (selected) {
        cardClassName = " techedge-card-selected";
        cardDescriptionName = "techedge-description-selected";
        cardTitleName = "techedge-card-title-selected";
    }

    return (
        <div className={cardClassName} onClick={onClick}>
            <div style={{ backgroundImage: `url(images/techEdge/${img})` }} className="techedge-image">&nbsp;</div>
            <div className="techedge-card-content">
                <span className={cardTitleName}>{tech}</span>
                <p className={cardDescriptionName}>{description}</p>
            </div>
        </div>
    );
};

export default TechEdgeCard;